import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { useScenarios } from './useScenarios'
import { BudgetingScenario } from '../types/BudgetingScenario'

type UseCtxScenarioProps = {
  scenarioId?: BudgetingScenario['id']
}

const useCtxScenario = ({ scenarioId }: UseCtxScenarioProps) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { data } = useScenarios({ companyId })
  return data?.find(item => item.id === scenarioId)
}

export default useCtxScenario
